export const CLIENT_API_KEY = process.env.NEXT_PUBLIC_CLIENT_KEY || '';

if (!CLIENT_API_KEY) throw Error(`Missing NEXT_PUBLIC_CLIENT_KEY environment variable!`);

const GATEWAY_API_URL_CONST = process.env.NEXT_PUBLIC_GATEWAY_API_URL;

if (!GATEWAY_API_URL_CONST) throw Error('No NEXT_PUBLIC_GATEWAY_API_URL environment variable set!');

export const GATEWAY_API_URL = GATEWAY_API_URL_CONST;

const GATEWAY_WS_API_URL_CONST = process.env.NEXT_PUBLIC_GATEWAY_WS_API_URL;

if (!GATEWAY_WS_API_URL_CONST)
  throw Error('No NEXT_PUBLIC_GATEWAY_WS_API_URL environment variable set!');

export const GATEWAY_API_WS_URL = new URL(GATEWAY_WS_API_URL_CONST);
